<template>
  <div class="flex flex-col items-center justify-center grow pl-3 pr-3 pt-7">
    <div class="flex flex-col p-4 gap-3 bg-primary rounded-4xl shadow-3xl">
      <div class="h-88 w-88 bg-black">
        <qrcode-stream @decode="handleDecode" />
      </div>
    </div>

    <div class="flex flex-col justify-center mt-4">
      <div class="flex flex-col gap-y-2 text-center pl-5 pt-5 pr-5 pb-0 mt-3">
        <div class="text-2xl font-medium text-primary break-words">
          {{ $t("components.passport.qr_codes.scan_title") }}
        </div>
        <div class="text-sm font-regular text-tertiary break-words mt-1">
          {{ description }}
        </div>
        <div class="pl-3 pt-3 pr-3 pb-0">
          <Button
            :label="$t('components.buttons.cancel')"
            variant="secondary"
            type="gray"
            size="lg"
            class="pl-4 pr-4 pt-2 pb-2 rounded-md button-secondary-gray-fg"
            @click="$emit('back')"
          />
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { Button } from "@/SharedComponents/Buttons";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["back"]);

const props = defineProps({
  type: { type: String, required: true },
  updateFn: { type: Function, required: true },
});

const { t } = useI18n();

const description = computed(() => {
  switch (props.type) {
    case "spaces":
      return t("components.passport.qr_codes.scan_space_description");
    default:
      return t("components.passport.qr_codes.scan_asset_description");
  }
});

async function handleDecode(url) {
  props.updateFn(url.split("/").pop()).finally(() => {
    emit("back");
  });
}
</script>
